import React from 'react';
import { Lock } from 'lucide-react';

interface AnalysisLimitMessageProps {
  todayAnalyses: number;
  limitPerDay: number;
  remainingAnalyses: number;
  isUnlimited?: boolean;
}

const AnalysisLimitMessage: React.FC<AnalysisLimitMessageProps> = ({
  todayAnalyses,
  limitPerDay,
  remainingAnalyses,
  isUnlimited = false
}) => {
  // Asegurar que los valores son números válidos
  const today = Number(todayAnalyses) || 0;
  const limit = Number(limitPerDay) || 1;
  const remaining = Number(remainingAnalyses) || 0;

  if (isUnlimited) {
    return (
      <div className="mb-4 p-4 bg-green-500/10 border border-green-500/20 rounded-lg">
        <div className="flex items-center space-x-2">
          <Lock className="h-5 w-5 text-green-500" />
          <div className="text-gray-300">
            <p>
              <span className="text-white font-medium">Plan Premium:</span>
              {' '}Análisis ilimitados. Has realizado {today} análisis hoy.
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="mb-4 p-4 bg-primary/10 border border-primary/20 rounded-lg">
      <div className="flex items-center space-x-2">
        <Lock className="h-5 w-5 text-primary" />
        <div className="text-gray-300">
          <p>
            <span className="text-white font-medium">Plan Gratuito:</span>
            {' '}Has realizado {today} de {limit} análisis disponibles hoy.
          </p>
          {remaining === 0 ? (
            <p className="mt-1">
              Has alcanzado el límite diario. <a href="/dashboard/subscription" className="text-primary hover:text-primary-hover">Actualiza a Premium</a> para análisis ilimitados.
            </p>
          ) : (
            <p className="mt-1">
              Te quedan {remaining} análisis disponibles hoy.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default AnalysisLimitMessage;